import { Pushbutton } from '@stratumn/atomic';
import { CheckboxTick } from '@stratumn/icons';
import { Box, Logo, TextInput } from 'components/ui';
import { ROUTE_LOGIN } from 'constant/routes';
import { validate as isValidEmail } from 'isemail';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';
import { Link } from 'react-router-dom';
import { SpanType, withSpanAsync } from 'tracing';
import { withRestClient } from 'wrappers';

import styles from './forgot.style';

export class Forgot extends React.PureComponent {
  static propTypes = {
    classes: PropType.object.isRequired,
    client: PropType.object.isRequired
  };

  state = {
    email: '',
    submitted: false,
    emailSent: false
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  isActive() {
    return !this.state.submitted && isValidEmail(this.state.email);
  }

  sendLink = async () =>
    withSpanAsync('forgot', SpanType.processing, async () => {
      const { email } = this.state;
      this.setState({ submitted: true });
      try {
        await this.props.client.forgot(email);
        this.setState({ emailSent: true });
      } catch (err) {
        this.setState({ submitted: false });
      }
    });

  render() {
    const { classes } = this.props;
    const { emailSent, email } = this.state;
    return (
      <>
        <Logo />
        <Box title="Forgot your password?">
          <div className={classes.text}>
            We'll get you back up and running soon! Enter your email and we'll
            send you a link to reset your password.
          </div>
          <TextInput
            autoFocus
            data-testid="email"
            disabled={emailSent}
            label="Email address"
            onChange={this.handleChange('email')}
            right
            top
            type="text"
            value={email}
          />
          <div className={classes.buttonRow}>
            <Pushbutton
              complete={emailSent}
              data-testid="button"
              disabled={!this.isActive()}
              onClick={this.sendLink}
              primary
            >
              {emailSent ? (
                <CheckboxTick className={classes.checkbox} />
              ) : (
                'Send link'
              )}
            </Pushbutton>
            {emailSent && (
              <div className={classes.emailSent} data-testid="email-sent">
                An email has been sent to this email address with a link to
                reset the password.
              </div>
            )}
          </div>
          <Link className={classes.backToSignIn} to={ROUTE_LOGIN}>
            Back to log in
          </Link>
        </Box>
      </>
    );
  }
}

export default compose(withRestClient, injectSheet(styles))(Forgot);
